import { CoachAvailabilitySlotPreview } from '@efdigital/ll-addon-coaching';
import type { CronofyElementsContext } from '@efdigital/ll-addon-coaching/types/cronofy-elements-context';
import type { TOC } from '@ember/component/template-only';

interface CoacheeSlotPreviewSignature {
  Args: {
    cronofyContext: CronofyElementsContext;
  };
  Element: HTMLElement;
}

/**
 * "What your coachees see": the coach's own bookable slots in the same picker
 * coachees book from, read-only.
 *
 * Coaches are usually in many cohorts, so there is deliberately no cohort
 * picker - the preview uses default cohort settings and says a coachee's own
 * cohort can narrow it.
 */
const CoacheeSlotPreview: TOC<CoacheeSlotPreviewSignature> = <template>
  <section
    aria-labelledby="coachee-slot-preview-heading"
    data-test-coachee-slot-preview
    ...attributes
  >
    <h4 id="coachee-slot-preview-heading" class="h5 mb-2">
      What your coachees see
    </h4>
    <p class="mb-3">
      These are the times a coachee can pick when booking a session with you.
      Choose a session length and a day to see its times.
    </p>
    <CoachAvailabilitySlotPreview @cronofyContext={{@cronofyContext}}>
      <p class="mb-0" data-test-coachee-slot-preview-note>
        This preview uses default cohort settings: a coachee's own cohort
        settings (scheduling window, notice period and allowed session lengths)
        can narrow what they see.
      </p>
    </CoachAvailabilitySlotPreview>
  </section>
</template>;

export default CoacheeSlotPreview;
